export const ORDER_AMT: string = "orderAmt";
export const CCY_CODE: string = "ccyCode";
export const CCY_PAIR_CODE: string = "ccyPairCode";
export const CCY_PAIR_INVERTED: string = "ccyPairInverted";
export const LIMIT_PRICE: string = "limitPrice";
export const RATE: string = "rate";
export const ICD_ID_LIMIT_PRICE = "c_limitprice";
